import { SchoolIcon } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
interface StandardCardMetadataProps {
  grade: string;
  subject: string;
  area: string;
}

/**
 * Metadata footer for StandardCard.
 * Displays: 📚 icon + "grade | subject | area"
 */
export const StandardCardMetadata = ({
  grade,
  subject,
  area
}: StandardCardMetadataProps) => {
  return <div className="flex items-center gap-xs overflow-hidden text-caption-lg-semibold text-neutral" data-sentry-component="StandardCardMetadata" data-sentry-source-file="StandardCardMetadata.tsx">
      {/* 학교급: 마지막에 줄어듦 (shrink-0) */}
      <span className="flex shrink-0 items-center gap-2xs overflow-hidden">
        <SchoolIcon size="2xs" fill={ICON_COLOR.alternative} className="shrink-0" data-sentry-element="SchoolIcon" data-sentry-source-file="StandardCardMetadata.tsx" />
        <span className="overflow-hidden text-ellipsis whitespace-nowrap">
          {grade}
        </span>
      </span>
      <Divider data-sentry-element="Divider" data-sentry-source-file="StandardCardMetadata.tsx" />
      {/* 과목: 두 번째로 줄어듦 */}
      <span className="min-w-0 shrink overflow-hidden text-ellipsis whitespace-nowrap">
        {subject}
      </span>
      <Divider data-sentry-element="Divider" data-sentry-source-file="StandardCardMetadata.tsx" />
      {/* 하위영역: 가장 먼저 줄어듦 */}
      <span className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap [flex-shrink:9999]">
        {area}
      </span>
    </div>;
};
const Divider = () => <div className="h-sm shrink-0 grow-0 border-x-[0.5px] border-neutral" data-sentry-component="Divider" data-sentry-source-file="StandardCardMetadata.tsx" />;